module.exports = __webpack_public_path__ + "img/checked.78d3ebc0.png";